// 报告的所有routes here
export default [
  {
    path: '/crazyrope/appeal-choose',
    name: 'crazyrope_appeal_choose',
    component: () => import('../../views/crazyrope/AppealChoose.vue'),
  },
  {
    path: '/crazyrope/appeal-success',
    name: 'crazyrope_appeal_success',
    component: () => import('../../views/crazyrope/AppealSuccess.vue'),
  },
  {
    path: '/crazyrope/apply-fame-hall',
    name: 'crazyrope_apply_fame_hall',
    component: () => import('../../views/crazyrope/ApplyFameHall/Index.vue'),
  },
  {
    path: '/crazyrope/drill-report-tip-off',
    name: 'crazyrope_drill_report_tip_off',
    component: () => import('../../views/crazyrope/DrillReportTipOff.vue'),
  },
  {
    path: '/crazyrope/fame-hall-certificate',
    name: 'crazyrope_fame_hall_certificate',
    component: () => import('../../views/crazyrope/FameHallCertificate.vue'),
  },
  {
    path: '/crazyrope/fame-hall-certificate-pacman',
    name: 'crazyrope_fame_hall_certificate_pacman',
    component: () => import('../../views/crazyrope/FameHallCertificatePacman.vue'),
  },
  {
    path: '/crazyrope/combination-training-report',
    name: 'combination_training_report',
    component: () => import('../../views/crazyrope/CombinationTraningReport.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/crazyrope/combination-training-share',
    name: 'combination_training_share',
    component: () => import('../../views/crazyrope/CombinationTrainingShare.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/crazyrope/drill-share',
    name: 'drill_share',
    component: () => import('../../views/crazyrope/DrillDetailShare.vue'),
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/competition/ranking-board-video',
    name: 'competition_ranking_board_video',
    props: (route: any) => ({ ...route.query, ...route.params }),
    component: () => import('../../views/crazyrope/RankingBoardVideo.vue'),
    meta: {
      title: '排行榜视频',
    },
  },
  {
    path: '/crazyrope/outdoor-run-report',
    name: 'outdoor_run_report',
    props: (route: any) => ({ id: route.query.id }),
    component: () => import('../../views/crazyrope/OutdoorRunReport.vue'),
    meta: {
      title: '户外跑报告',
    },
  },
]
